import { createContext, useContext } from 'react';

/**
 * Studio request decorations injected onto every video-operation request
 * (mirrors Image/Writer Lab). The Animation Lab shell provides the active
 * `studioId` + a selection-derived `metadata` block (the `studio_motion`
 * key); `useVideoOperationMutation` reads this and gap-fills it onto each
 * request so studio-typed metadata is validated + persisted server-side.
 *
 * Default is empty (no decoration) so operations run unchanged in tests.
 */
export interface StudioRequestValue {
  studioId?: string;
  metadata?: Record<string, unknown>;
}

export const StudioRequestContext = createContext<StudioRequestValue>({});

export function useStudioRequest(): StudioRequestValue {
  return useContext(StudioRequestContext);
}
